
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import StatsCards from '../components/Dashboard/StatsCards';
import Charts from '../components/Dashboard/Charts';
import { isAuthenticated } from '../utils/auth';
import api from '../services/api';
import { Stats, ChartData } from '../types';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Dashboard');
  const [stats, setStats] = useState<Stats>({
    totalCalls: 0,
    totalConversations: 0,
    totalTranscriptions: 0
  });
  const [chartData, setChartData] = useState<ChartData[]>([
    { name: 'Mon', value: 0 },
    { name: 'Tue', value: 0 },
    { name: 'Wed', value: 0 },
    { name: 'Thu', value: 0 },
    { name: 'Fri', value: 0 },
    { name: 'Sat', value: 0 },
    { name: 'Sun', value: 0 },
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/login');
      return;
    }
    fetchDashboardData();
  }, [navigate]);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/dashboard/stats');
      console.log('Dashboard API Response:', response.data);
      
      if (response.data.success) {
        const data = response.data.data;
        setStats({
          totalCalls: data.total_calls || 0,
          totalConversations: data.total_conversations || 0,
          totalTranscriptions: data.total_transcriptions || 0
        });
        
        setChartData([
          { name: 'Mon', value: 5 },
          { name: 'Tue', value: 8 },
          { name: 'Wed', value: 12 },
          { name: 'Thu', value: 7 },
          { name: 'Fri', value: 15 },
          { name: 'Sat', value: 10 },
          { name: 'Sun', value: 6 },
        ]);
      }
    } catch (err: any) {
      console.error('Error fetching dashboard data:', err);
      setError(err.response?.data?.message || 'Failed to load dashboard data');
      // Fallback to static data
      setStats({
        totalCalls: 3,
        totalConversations: 1,
        totalTranscriptions: 3
      });
      setChartData([
        { name: 'Mon', value: 5 },
        { name: 'Tue', value: 8 },
        { name: 'Wed', value: 12 },
        { name: 'Thu', value: 7 },
        { name: 'Fri', value: 15 },
        { name: 'Sat', value: 10 },
        { name: 'Sun', value: 6 },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    navigate(`/${tab.toLowerCase()}`);
  };

  if (!isAuthenticated()) {
    return null;
  }

  if (loading) {
    return (
      <div className="dashboard">
        <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
        <div className="dashboard-content">
          <div style={{ textAlign: 'center', padding: '50px' }}>Loading dashboard data...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
      <div className="dashboard-content">
        <h1>Dashboard Overview</h1>
        {error && <div style={{ color: 'red', marginBottom: '1rem', padding: '10px', background: '#ffebee', borderRadius: '5px' }}>{error}</div>}
        <StatsCards stats={stats} />
        <Charts data={chartData} />
      </div>
    </div>
  );
};

export default Dashboard;